import { ILoggerService, LogLevel } from "./ILoggerService";

///window.stacktrace = true;
export class LoggerService implements ILoggerService {
    private _blockedServices: string[] = [];
    public static readonly ServiceName: string = "LoggerService";
    public static DoesThrowStackTrace: boolean = false;

    public constructor() {
        const g = globalThis as any;

        if (g.loglevel !== undefined && g.loglevel !== null)
            this._logLevel = g.loglevel;

        g.logger = this;
    }

    public EnableStackTrace(): void {
        LoggerService.DoesThrowStackTrace = true;
    }

    public DisableStackTrace(): void {
        LoggerService.DoesThrowStackTrace = false;
    }

    private IsBlocked<T>(service: string): boolean {
        if (service === undefined)
            return false;

        return this._blockedServices.any(a => a == service);
    }

    DisableLogsFrom(name: string): void {
        if (this._blockedServices.all(a => a != name))
            this._blockedServices.push(name);

        this.Debug(LoggerService.ServiceName, `Disabling logs from ${name}`);
    }

    EnableLogsFrom(name: string): void {
        if (this._blockedServices.any(a => a == name))
            this._blockedServices = this._blockedServices.where(a => a != name).toArray();

        this.Debug(LoggerService.ServiceName, `Enaabling logs from ${name}`);
    }

    private _logLevel: LogLevel = LogLevel.Debug;

    get LogLevel(): LogLevel {
        return this._logLevel;
    }

    set LogLevel(level: LogLevel) {
        this._logLevel = level;
    }

    GetServiceName(): string {
        return LoggerService.ServiceName;
    }

    private GetTimeStamp(): string {
        const date = new Date();
        return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()} | `;
    }
    Warning(message: string): void;
    Warning(contextClassType: string, message: string): void;
    Warning(contextClassType: unknown, message?: unknown): void {

        switch (this._logLevel) {
            case LogLevel.Warning:
            case LogLevel.Info:
            case LogLevel.Debug:
                break;

            case LogLevel.None:
            default:
                return;
        }

        if (contextClassType === undefined || this.IsBlocked(contextClassType as string))
            return;

        if (contextClassType != null)
            if (message === null || message === undefined)
                console.warn(`${this.GetTimeStamp()}[WARN] ${contextClassType}`);
            else
                console.warn(`${this.GetTimeStamp()}[WARN] [${contextClassType}] ${message}`);
    }

    Error(message: string): void;
    Error(contextClassType: string, message: string): void;
    Error(contextClassType: unknown, message?: unknown): void {
        switch (this._logLevel) {
            case LogLevel.Warning:
            case LogLevel.Info:
            case LogLevel.Debug:
            case LogLevel.Error:
                break;

            case LogLevel.None:
            default:
                return;
        }

        if (contextClassType != null)
            if (message === null || message === undefined)
                console.error(`${this.GetTimeStamp()}[ERROR] ${contextClassType}`);
            else
                console.error(`${this.GetTimeStamp()}[ERROR] [${contextClassType}] ${message}`);
    }

    Info(message: string): void;
    Info(contextClassType: string, message: string): void;
    Info(contextClassType: unknown, message?: unknown): void {

        switch (this._logLevel) {
            case LogLevel.Info:
            case LogLevel.Debug:
                break;

            case LogLevel.None:
            default:
                return;
        }

        if (contextClassType === undefined || this.IsBlocked(contextClassType as string))
            return;

        if (contextClassType != null)
            if (message === null || message === undefined)
                console.info(`${this.GetTimeStamp()}[INFO] ${contextClassType}`);
            else
                console.info(`${this.GetTimeStamp()}[INFO] [${contextClassType}] ${message}`);
    }

    Debug(message: string): void;
    Debug(contextClassType: string, message: string): void;
    Debug(contextClassType: unknown, message?: unknown): void {

        switch (this._logLevel) {
            case LogLevel.Debug:
                break;

            case LogLevel.None:
            default:
                return;
        }

        if (contextClassType === undefined || this.IsBlocked(contextClassType as string))
            return;

        if (contextClassType != null)
            if (message === null || message === undefined)
                console.debug(`${this.GetTimeStamp()}[DEBUG] ${contextClassType}`);
            else if (LoggerService.DoesThrowStackTrace || (globalThis as any)["stacktrace"] === true)
                console.debug(`${this.GetTimeStamp()}[DEBUG] [${contextClassType}] ${message} \nstack:\n${new Error().stack}}`);
            else
                console.debug(`${this.GetTimeStamp()}[DEBUG] [${contextClassType}] ${message}`);
    }

    Log(message: string): void;
    Log(contextClassType: string, message: string): void;
    Log(contextClassType: unknown, message?: unknown): void {
        switch (this._logLevel) {
            case LogLevel.None:
                return;

            default:
                break;
        }


        if (contextClassType === undefined || this.IsBlocked(contextClassType as string))
            return;

        if (contextClassType != null)
            if (message === null || message === undefined)
                console.log(`${this.GetTimeStamp()}[LOG] ${contextClassType}`);
            else
                console.log(`${this.GetTimeStamp()}[LOG] [${contextClassType}] ${message}`);
    }
}
